module.exports = __webpack_public_path__ + "img/join4-2-h.c9d0a21d.svg";